import { render, staticRenderFns } from "./electricity.vue?vue&type=template&id=2f83ef2e&scoped=true"
import script from "./electricity.vue?vue&type=script&lang=js"
export * from "./electricity.vue?vue&type=script&lang=js"
import style0 from "./electricity.vue?vue&type=style&index=0&id=2f83ef2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83ef2e",
  null
  
)

export default component.exports